import { render, staticRenderFns } from "./TabInsight.vue?vue&type=template&id=3951de56"
import script from "./TabInsight.vue?vue&type=script&lang=js"
export * from "./TabInsight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports